var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"notif-cart-icon icon-basket-wrapper"},[_c('span',{staticClass:"icon-basket-img"},[_c('span',{staticClass:"icon-basket-count",class:{pulse1 : _vm.pulse}},[_vm._v(_vm._s(_vm.totalItems))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69080ecb","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./Vue/Src/Components/basket-count.vue
// module id = 39
// module chunks = 0 1 2